export const WEB_SOCKETS_LOCAL_STORAGE_KEY = 'useWebSockets';
